import type React from 'react'

export const AddToFavoritesModalSkeleton: React.FC = () => {
  return (
    <div className="max-h-68 w-full space-y-2 overflow-y-auto">
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="flex w-full flex-row items-center justify-between border-border-default border-t px-4 py-2 last:border-b"
        >
          <div className="flex w-full flex-col gap-2">
            <div className="h-4 w-3/5 animate-pulse rounded-sm bg-button-disabled"></div>
            <div className="h-3 w-2/5 animate-pulse rounded-sm bg-button-disabled"></div>
          </div>
          <div className="ml-4 h-8 w-8 animate-pulse rounded-full bg-button-disabled"></div>
        </div>
      ))}
    </div>
  )
}
